<script setup>
import EditInput from "@/components/global/inputs/EditInput.vue";
import { ref } from "vue";

const props = defineProps({
  discountCode: {
    type: String,
    required: true,
  },
  organisationId: {
    type: Number,
    required: true,
  },
});

const discountCode = ref(props.discountCode);

const updateUrl = `/admin/crm/organisations/${props.organisationId}/update-discount-code`;

const success = (event) => discountCode.value = event;
</script>

<template>
  <EditInput
    :url="updateUrl"
    :current-value="discountCode"
    @success="success"
  >
    <span>
      {{ discountCode }}
    </span>
  </EditInput>
</template>
